import { Box, Typography, IconButton } from "@mui/material";
import { styled } from "@mui/system";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import EmailIcon from "@mui/icons-material/Email";
import logo from "../assets/logo.png";

const FooterContainer = styled(Box)({
  backgroundColor: "#000000",
  padding: "40px 20px 20px",
  marginTop: "60px",
  width: "100%",
});

const FooterSection = styled(Box)({
  marginBottom: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
});

const FooterLink = styled(Typography)({
  fontSize: "14px",
  color: "#b0b0b0",
  textDecoration: "none",
  cursor: "pointer",
  "&:hover": {
    color: "#fff",
  },
});

const FooterText = styled(Typography)({
  fontSize: "14px",
  color: "#b0b0b0",
  textAlign: "center",
});

const Footer = () => {
  const isMobileView = window.innerWidth < 600;

  return (
    <FooterContainer>
      <Box
        sx={{
          maxWidth: "800px",
          margin: "0 auto",
          borderTop: "1px solid #444",
          paddingTop: "20px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: isMobileView ? "center" : "flex-start",
            flexDirection: isMobileView ? "column" : "row",
            gap: isMobileView ? "20px" : "0",
            paddingBottom: "20px",
          }}
        >
          <FooterSection sx={{ marginBottom: isMobileView ? "0" : "20px" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: "8px",
                justifyContent: "center",
              }}
            >
              <img
                src={logo}
                alt="PledgeFast Logo"
                style={{ width: "40px", height: "40px", marginRight: "10px" }}
              />
              <Typography variant="h6" sx={{ color: "#fff", fontWeight: "bold" }}>
                PledgeFast
              </Typography>
            </Box>
            <FooterText>Dog Rescue Platform</FooterText>
          </FooterSection>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: isMobileView ? "center" : "flex-end",
              gap: "12px",
            }}
          >
            <IconButton
              sx={{ color: "#b0b0b0", "&:hover": { color: "#fff" } }}
              onClick={() => window.open("https://twitter.com/pledgefast_com", "_blank")}
              aria-label="Twitter"
            >
              <TwitterIcon />
            </IconButton>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: isMobileView ? "center" : "flex-end",
              }}
            >
              <FooterLink onClick={() => (window.location.href = "/privacy")}>
                Privacy Policy
              </FooterLink>
              <FooterLink onClick={() => (window.location.href = "/terms")}>
                Terms of Service
              </FooterLink>
            </Box>
          </Box>
        </Box>

        <Box sx={{ textAlign: "center" }}>
          <FooterText>
            © {new Date().getFullYear()} PledgeFast. All rights reserved.
          </FooterText>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              marginTop: "12px",
            }}
          >
            <EmailIcon sx={{ fontSize: "16px", color: "#b0b0b0" }} />
            <FooterLink
              component="a"
              href="mailto:onepaceapps@gmail.com"
              sx={{
                textDecoration: "none",
                "&:hover": {
                  color: "#fff",
                  textDecoration: "underline",
                },
              }}
            >
              onepaceapps@gmail.com
            </FooterLink>
          </Box>
        </Box>
      </Box>
    </FooterContainer>
  );
};

export default Footer;
